export const DEFAULT_TAILSCALE_PROXY_PORT_V816 = 1055;

export const buildTailscaleServerOptionsV816 = (
  servers = [],
  selectedServer = '',
  labels = {}
) => {
  const statusLabels = {
    available: labels.available || 'Available',
    offline: labels.offline || 'Offline',
    proxyUnavailable: labels.proxyUnavailable || 'SOCKS5 unavailable',
    savedUnavailable: labels.savedUnavailable || 'Saved server unavailable',
  };
  const seen = new Set();
  const options = (Array.isArray(servers) ? servers : [])
    .map((server) => {
      const dnsName = String(server?.dns_name || '')
        .trim()
        .replace(/\.$/, '')
        .toLowerCase();
      if (!dnsName || seen.has(dnsName)) {
        return null;
      }
      seen.add(dnsName);
      const available =
        server?.online === true && server?.proxy_available === true;
      const status = !server?.online
        ? statusLabels.offline
        : available
        ? statusLabels.available
        : statusLabels.proxyUnavailable;
      const name = String(server?.name || dnsName).trim();
      return {
        key: dnsName,
        value: dnsName,
        text: `${name} - ${status}`,
        disabled: !available,
      };
    })
    .filter(Boolean);

  const selected = String(selectedServer || '')
    .trim()
    .replace(/\.$/, '')
    .toLowerCase();
  if (selected && !seen.has(selected)) {
    options.unshift({
      key: `saved-${selected}`,
      value: selected,
      text: `${selected} - ${statusLabels.savedUnavailable}`,
      disabled: true,
    });
  }
  return options;
};

export const normalizeChannelEgressConfigV816 = (config = {}) => {
  const upstreamProxy = String(config.upstream_proxy || '').trim();
  const configuredMode = String(config.egress_mode || '')
    .trim()
    .toLowerCase();
  const egressMode = ['direct', 'proxy', 'tailscale'].includes(configuredMode)
    ? configuredMode
    : upstreamProxy
    ? 'proxy'
    : 'direct';
  const parsedPort = Number.parseInt(config.tailscale_proxy_port, 10);
  return {
    ...config,
    egress_mode: egressMode,
    upstream_proxy: upstreamProxy,
    tailscale_server: String(config.tailscale_server || ''),
    tailscale_proxy_port:
      Number.isInteger(parsedPort) && parsedPort > 0
        ? parsedPort
        : DEFAULT_TAILSCALE_PROXY_PORT_V816,
  };
};

export const isProxyEnabledV816 = (config = {}) =>
  normalizeChannelEgressConfigV816(config).egress_mode !== 'direct';

export const buildChannelEgressSubmissionV816 = (config = {}) => {
  const normalized = normalizeChannelEgressConfigV816(config);
  if (normalized.egress_mode === 'direct') {
    delete normalized.upstream_proxy;
    delete normalized.tailscale_server;
    delete normalized.tailscale_proxy_port;
  } else if (normalized.egress_mode === 'proxy') {
    normalized.upstream_proxy = String(normalized.upstream_proxy || '').trim();
    delete normalized.tailscale_server;
    delete normalized.tailscale_proxy_port;
  } else {
    delete normalized.upstream_proxy;
    normalized.tailscale_server = String(normalized.tailscale_server || '')
      .trim()
      .replace(/\.$/, '')
      .toLowerCase();
  }
  return normalized;
};
